import cloneDeep from 'lodash/cloneDeep';
import actionTypes from 'app/actions/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_WIDGETS_SUCCESS:
      return action.home ? [] : cloneDeep(action.items);
    case actionTypes.CANCEL_WIDGETS_CHANGES:
      return [...action.copyItems];
    case actionTypes.ADD_WIDGET:
      return [...state, action.widget];
    case actionTypes.UPDATE_WIDGET:
      return state.map((item, index) => (index === action.index ? { ...item, ...action.widget } : item));
    case actionTypes.DELETE_WIDGET:
      return [...state.slice(0, action.index), ...state.slice(action.index + 1)];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/widgets/copy-items.js